import { motion } from 'framer-motion'
import { Sparkles, TrendingUp } from 'lucide-react'

import { useCommandDashboard } from '@/contexts/CommandDashboardContext'

export function TodaysOpportunities() {
  const { data } = useCommandDashboard()
  const opp = data?.opportunities ?? {}
  const hints = Array.isArray(opp.hints) ? opp.hints : []

  const items = [
    {
      label: 'Upsell potential',
      value: opp.upsell_potential ? `AED ${opp.upsell_potential}` : '—',
      hint: hints[0] ?? 'Upcoming appointments',
    },
    {
      label: 'Eligible for upsell',
      value: opp.eligible_guest_count != null ? `${opp.eligible_guest_count} guests` : '—',
      hint: 'Add-on services suggested',
    },
    {
      label: 'Open slots',
      value: opp.open_slot_count != null ? String(opp.open_slot_count) : '—',
      hint: 'Upcoming on calendar',
    },
    {
      label: 'Revenue opportunity',
      value: opp.revenue_opportunity ? `AED ${opp.revenue_opportunity}` : '—',
      hint: hints[1] ?? 'If slots convert today',
    },
  ]

  return (
    <motion.section
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="card-surface bg-gradient-to-br from-gold/[0.06] to-card p-4"
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-gold" />
          <h2 className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            Today&apos;s opportunities
          </h2>
        </div>
        <TrendingUp className="h-3.5 w-3.5 text-emerald-600" />
      </div>
      <div className="grid grid-cols-2 gap-2">
        {items.map((op) => (
          <div
            key={op.label}
            className="rounded-xl bg-white/60 px-2.5 py-2 shadow-sm transition-colors hover:bg-white/90"
            style={{ border: '1px solid hsl(262 20% 50% / 0.04)' }}
          >
            <p className="text-[9px] font-semibold uppercase tracking-wide text-muted-foreground">
              {op.label}
            </p>
            <p className="mt-0.5 text-sm font-bold tabular-nums">{op.value}</p>
            <p className="text-[10px] text-muted-foreground">{op.hint}</p>
          </div>
        ))}
      </div>
    </motion.section>
  )
}
